<template>
  <div>
    <b-col md="12" class="component-margin">
      <b-row>
        <b-col md="12" class="margin">
          <b-button size="md" @click="bootSpreadsheet()" variant="danger">スプレッドシート起動</b-button>
          <b-button v-if="!imported" @click="importItems()" class="margin-left-5" size="md" variant="danger">データ取込</b-button>
          <b-button v-else size="md" @click="reimportItems()" class="margin-left-5" variant="danger">データ再取込</b-button>
          <b-button v-if="!hasErrors" size="md" @click="registerItemsConfirm()" class="margin-left-5" variant="danger">LAS登録実行</b-button>
          <b-button v-else size="md" class="margin-left-5" disabled variant="danger">LAS登録実行</b-button>
          <item-registration-deposit :deposit="deposit" :requireDeposit="requireDeposit" :isWarnDeposit="isWarnDeposit"/>
          <item-registration-form-link/>
        </b-col>
      </b-row>
    </b-col>
    <b-col sm="12">
    <b-table show-empty stacked=md bordered=true striped=true small=true hover=true
             :items="items" :fields="fields" :filter="filter"
             :sort-by.sync="sortBy" :sort-desc.sync="sortDesc" :sort-direction="sortDirection">
      <template slot="inboundDate" slot-scope="row">
        <label>{{formatDate(row.value)}}</label>
      </template>
      <template slot="productCondition" slot-scope="row">
        <label>{{conditionTypeText(row.value)}}</label>
      </template>
      <template slot="purchaseUnitPrice" slot-scope="row">
        <label>{{formatPrice(row.value)}}</label>
      </template>
      <template slot="forcastShippingCost" slot-scope="row">
        <label>{{formatPrice(row.value)}}</label>
      </template>
      <template slot="forcastTargetSales" slot-scope="row">
        <label>{{formatPrice(row.value)}}</label>
      </template>
      <template slot="forcastTargetProfit" slot-scope="row">
        <label>{{formatPrice(row.value)}}</label>
      </template>
      <template slot="matomeStatus" slot-scope="row">
        <label>{{existTypeText(row.value)}}</label>
      </template>
      <template slot="status" slot-scope="row">
        <label>{{SpreadSheetStatusText(row.value)}}</label>
      </template>
      <template slot="message" slot-scope="row">
        <ul>
          <li v-for='(value, index) in row.item.messages' :key='index'>
            {{ value }}
          </li>
        </ul>
      </template>
    </b-table>
    </b-col>
    <!-- <b-col md="6">
      <b-pagination :total-rows="totalRows" :per-page="perPage" v-model="currentPage"/>
    </b-col> -->
    <b-modal ref="registerItemsConfirm" @ok="registerItems" hide-header>
      <div class="text-center">データの取り込みを実施します。</div>
    </b-modal>
    <b-modal ref="messagePopup" ok-only hide-header>
      <div class="text-center">{{confirmMessage}}</div>
    </b-modal>
  </div>
</template>

<script>
import Vue from 'vue';
import BaseComponent from '@/components/BaseComponent';
import ConditionType from '@/types/ConditionType';
import ExistType from '@/types/ExistType';
import SpreadSheetStatus from '@/types/SpreadSheetStatus';
import ItemRegistrationDispDeposit from '@/components/item-registration/ItemRegistrationDispDeposit';
import ItemRegistrationFormLink from '@/components/item-registration/ItemRegistrationFormLink';
import * as api from '@/api';
import * as utility from '@/utility';

export default {
  mixins: [BaseComponent],
  props: {
    deposit: { default: 0},
    requireDeposit: { default: 0},
    isWarnDeposit: { default: false}
  },
  data() {
    return {
      items: [],
      fields: [
        { key: 'inboundDate', label: '購入日', sortable: true, variant: 'base' },
        { key: 'productCondition', label: '状態', sortable: true, variant: 'base' },
        { key: 'asin', label: 'ASIN', sortable: true, variant: 'base' },
        { key: 'janCode', label: 'JANコード', sortable: true, variant: 'base' },
        { key: 'purchaseQuantity', label: '購入数', sortable: true, variant: 'base', class: 'table-right' },
        { key: 'purchaseUnitPrice', label: '単価', sortable: true, variant: 'base', class: 'table-right' },
        { key: 'shopName', label: '購入店', sortable: true, variant: 'base' },
        { key: 'sku', label: 'SKU(任意)', sortable: true, variant: 'base' },
        { key: 'remark', label: '備考', sortable: true, variant: 'base' },
        { key: 'forcastShippingCost', label: '見込み送料', sortable: true, variant: 'base', class: 'table-right' },
        { key: 'forcastTargetSales', label: 'T売上', sortable: true, variant: 'base', class: 'table-right' },
        { key: 'forcastTargetProfit', label: 'T利益', sortable: true, variant: 'base', class: 'table-right' },
        { key: 'matomeStatus', label: '特殊便依頼', sortable: true, variant: 'base' },
        { key: 'status', label: 'Status', sortable: true, variant: 'base' },
        { key: 'message', label: 'メッセージ', sortable: true, variant: 'base' },
      ],
      // currentPage: 1,
      // perPage: 25,
      totalRows: 0,
      sortBy: null,
      sortDesc: false,
      sortDirection: 'asc',
      filter: null,
      activate: false,
      imported: false,
      hasErrors: true,
      confirmMessage: '',
    };
  },
  methods: {
    conditionTypeText(item) {
      return ConditionType.valueOf(item).text;
    },
    existTypeText(item) {
      return ExistType.valueOf(item).text;
    },
    SpreadSheetStatusText(item) {
      return SpreadSheetStatus.valueOf(item).text;
    },
    bootSpreadsheet() {
      api.getSpreadSheetUrl((url) => {
        window.open(url.spreadsheet, '_blank');
      });
    },
    importItems() {
      api.getItemRegistration((items) => {
        this.items = items;
        this.totalRows = this.items.length;
        this.addCellVariant();
        this.imported = true;
      });
    },
    reimportItems() {
      api.getItemRegistration((items) => {
        this.items = items;
        this.totalRows = this.items.length;
        this.addCellVariant();
        this.imported = true;
      });
    },
    registerItemsConfirm() {
      this.$refs.registerItemsConfirm.show();
    },
    registerItems() {
      api.registerItemRegistration(this.items, (data) => {
        this.items = [];
        this.totalRows = this.items.length;
        this.imported = false;
        this.hasErrors = true;
        this.confirmMessage = '登録完了しました。';
        this.$refs.messagePopup.show();
      });
    },
    addCellVariant() {
      this.hasErrors = false;
      if (this.items.length < 1) {
        this.hasErrors = true;
      }
      for (const v of this.items) {
        let hasError = false;
        const errorCells = [];
        if (v.errorInboundDate !== null && v.errorInboundDate === true) {
          errorCells.inboundDate = 'danger';
          hasError = true;
        }
        if (v.errorProductCondition !== null && v.errorProductCondition === true) {
          errorCells.productCondition = 'danger';
          hasError = true;
        }
        if (v.errorAsin !== null && v.errorAsin === true) {
          errorCells.asin = 'danger';
          hasError = true;
        }
        if (v.errorJanCode !== null && v.errorJanCode === true) {
          errorCells.janCode = 'danger';
          hasError = true;
        }
        if (v.errorPurchaseQuantity !== null && v.errorPurchaseQuantity === true) {
          errorCells.purchaseQuantity = 'danger';
          hasError = true;
        }
        if (v.errorPurchaseUnitPrice !== null && v.errorPurchaseUnitPrice === true) {
          errorCells.purchaseUnitPrice = 'danger';
          hasError = true;
        }
        if (v.errorShopName !== null && v.errorShopName === true) {
          errorCells.shopName = 'danger';
          hasError = true;
        }
        if (v.errorSku !== null && v.errorSku === true) {
          errorCells.sku = 'danger';
          hasError = true;
        }
        if (v.errorRemark !== null && v.errorRemark === true) {
          errorCells.remark = 'danger';
          hasError = true;
        }
        if (v.errorForcastShippingCost !== null && v.errorForcastShippingCost === true) {
          errorCells.forcastShippingCost = 'danger';
          hasError = true;
        }
        if (v.errorForcastTargetSales !== null && v.errorForcastTargetSales === true) {
          errorCells.forcastTargetSales = 'danger';
          hasError = true;
        }
        if (v.errorForcastTargetProfit !== null && v.errorForcastTargetProfit === true) {
          errorCells.forcastTargetProfit = 'danger';
          hasError = true;
        }
        if (v.errorMatomeStatus !== null && v.errorMatomeStatus === true) {
          errorCells.matomeStatus = 'danger';
          hasError = true;
        }
        if (hasError) {
          errorCells.status = 'danger';
          this.hasErrors = true;
        } else{
          if(v.status === 'WARN'){
            errorCells.status = 'warning';
          }
        }
        v._cellVariants = errorCells;
      }
    },
  },
};

Vue.component('item-registration-deposit', ItemRegistrationDispDeposit);
Vue.component('item-registration-form-link', ItemRegistrationFormLink);

</script>

<style>
.component-margin {
  margin-bottom: 1rem;
}

.margin-left {
    margin-left: 1rem;
}
.margin-left-5 {
    margin-left: 5rem;
}

th.table-base {
  background-color: aliceblue!important;
}

th.table-ans {
  background-color: beige!important;
}

@media (min-width: 768px) {
  .table-right { text-align: right; }
}
</style>
